import { useQuery } from '@tanstack/react-query';
import { BriefChainStore } from '../../models/chain-store.ts';
import { fetchBriefChainStores } from '../../api/partner.ts';

export default function useBriefChainStores(partnerId: string) {
  return useQuery<BriefChainStore[]>({
    queryKey: ['partnerBriefChainStores', partnerId],
    queryFn: () => fetchBriefChainStores(partnerId),
  });
}
